import { httpClient } from '../httpClient';

export const assessmentMethods = {
  getAssessment: (departmentId) =>
    departmentId
      ? httpClient.get('/pdpl/assessment', { params: { department_id: departmentId } })
      : httpClient.get('/pdpl/assessment'),

  runAutoAssessment: (departmentId) =>
    httpClient.post('/pdpl/assessment/auto', undefined, departmentId ? { params: { department_id: departmentId } } : {}),

  saveManualAssessment: (answers) =>
    httpClient.post('/pdpl/assessment/manual', { answers }),

  ensureSession: (departmentId) =>
    httpClient.post('/pdpl/assessment/ensure-session', undefined, departmentId ? { params: { department_id: departmentId } } : {}),

  exportPdf: (payload) =>
    httpClient.post('/pdpl/assessment/export-pdf', payload, { responseType: 'blob' }),

  getSdaiaQuestions: (category) =>
    httpClient.get('/pdpl/sdaia/questions', { params: category ? { category } : {} }),

  getSdaiaResponses: (assessmentId) =>
    httpClient.get(`/pdpl/sdaia/responses/${assessmentId}`),

  saveSdaiaResponses: (assessmentId, responses) =>
    httpClient.post('/pdpl/sdaia/responses', { assessment_id: assessmentId, responses }),

  // ── History (US12 / AC-15) ─────────────────────────────────────
  getHistory: (params) =>
    httpClient.get('/pdpl/assessment/history', { params }),

  // ── Approval workflow ──────────────────────────────────────────
  // C-APV-2 (2026-04-27) replaced the assessment-level approval lifecycle
  // with the per-category lifecycle in approval_workflow_routes.py.
  // The cross-assessment "what's waiting on me" inbox is now served by
  // /pdpl/approvals/pending; per-category approve/reject (with step-up
  // + attestation capture) are invoked from the in-context
  // ApprovalReviewBanner, not from the inbox.
  getPendingApprovals: () =>
    httpClient.get('/pdpl/approvals/pending'),

  downloadApprovalPackage: (assessmentId) =>
    httpClient.get(`/pdpl/assessment/${assessmentId}/approval-package`, {
      responseType: 'blob',
    }),

  // ── Assessment soft-delete (US11) ──────────────────────────────
  deleteAssessment: (assessmentId) =>
    httpClient.delete(`/pdpl/assessment/${assessmentId}`),

  // ── Command Center (US16) ──────────────────────────────────────
  getCommandCenter: (params) =>
    httpClient.get('/pdpl/command-center', { params }),

  // ── SDAIA auto-fill + export (US17) ───────────────────────────
  autoFillSdaia: (assessmentId) =>
    httpClient.post(`/pdpl/sdaia/auto-fill/${assessmentId}`),

  exportSdaia: (assessmentId, fmt) =>
    httpClient.get(`/pdpl/sdaia/export/${assessmentId}`, {
      params: { format: fmt },
      responseType: 'blob',
    }),

  // ── Regulatory Monitor (US19) ──────────────────────────────────
  createRegulatoryUpdate: (data) =>
    httpClient.post('/pdpl/regulatory-updates', data),

  listRegulatoryUpdates: () =>
    httpClient.get('/pdpl/regulatory-updates'),

  updateRegulatoryUpdate: (id, data) =>
    httpClient.patch(`/pdpl/regulatory-updates/${id}`, data),

  deleteRegulatoryUpdate: (id) =>
    httpClient.delete(`/pdpl/regulatory-updates/${id}`),

  getRegulatoryImpact: (updateId) =>
    httpClient.get(`/pdpl/regulatory-updates/${updateId}/impact`),

  // ── Plan 2 Task 18 — per-assessment regulatory update impact (P1-12) ─────
  // Same URL as the legacy ``getRegulatoryImpact`` but threads an
  // ``assessment_id`` query param so the backend can attach the DPO's
  // current per-question answer. Returns the unwrapped payload directly
  // (no axios envelope) — consumers read ``affected_count``,
  // ``affected_questions``, ``review_all_url`` straight off the resolved
  // promise. Cache-keyed by both (updateId, assessmentId) so two open
  // assessments don't share a stale view.
  getRegulatoryUpdateImpact: (updateId, assessmentId) =>
    httpClient
      .get(`/pdpl/regulatory-updates/${updateId}/impact`, {
        params: assessmentId != null ? { assessment_id: assessmentId } : {},
      })
      .then((res) => res?.data?.data ?? res?.data ?? {}),

  // ── Maturity Model (US20) ──────────────────────────────────────
  getMaturity: (params) =>
    httpClient.get('/pdpl/maturity', { params }),

  getMaturityHistory: (params) =>
    httpClient.get('/pdpl/maturity/history', { params }),

  getMaturityGapReport: (params) =>
    httpClient.get('/pdpl/maturity/gap-report', { params }),
};
